import { eTlfItemType } from "functions/api/enums";
import { pickVariantUpdateable } from "functions/tlf/pickVariantUpdateable";
import { commitActivePatch } from "./commitActivePatch";
import { getVariantPatchContext } from "./getVariantPatchContext";
import {
  ITlfActionRevertToVariantMaster,
  SET_VARIANT_CREATION_VIEW,
  TlfContextProps,
  UPDATE_TLF,
} from "./interface";
import { tlf_setVariantCreationMode } from "./tlf_setVariantCreationMode";
import { tlf_updateTlf } from "./tlf_updateTlf";
import { updateActivePatchErrors } from "./updateActivePatchErrors";

/**
 * Commits the active patch and restores the variant-editable fields from the master snapshot.
 *
 * @param state - Current TLF context state
 * @param action - Revert command metadata
 * @returns State restored to the master with no applied or active patches
 */
export const tlf_revertToVariantMaster = (
  state: TlfContextProps,
  action: ITlfActionRevertToVariantMaster,
): TlfContextProps => {
  const { state: committedState, catalog } = commitActivePatch(state, action.calledFrom);
  const { master, currentMaster } = getVariantPatchContext(committedState);
  if (catalog === null || master === null || currentMaster === null) return committedState;
  const tlfData =
    master.type === eTlfItemType.arsListing
      ? { type: master.type, ...pickVariantUpdateable(master), allVariantPatches: catalog }
      : { type: master.type, ...pickVariantUpdateable(master), allVariantPatches: catalog };
  const updated = tlf_updateTlf(committedState, {
    operation: UPDATE_TLF,
    tlfData,
    calledFrom: action.calledFrom,
  });
  const unselected: TlfContextProps = {
    ...updated,
    appliedVariantPatches: [],
    activeVariantPatchName: null,
  };
  const newState = tlf_setVariantCreationMode(unselected, {
    operation: SET_VARIANT_CREATION_VIEW,
    variantCreationView: false,
    calledFrom: action.calledFrom,
  });
  return updateActivePatchErrors(newState);
};
